import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/juice.svg` */
export const JuiceSolidIcon = createTripletGlyphIcon('JuiceSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1301 10.4004C10.2817 10.8934 10.2474 11.4252 10.0334 11.8945C9.81934 12.3638 9.44064 12.7394 8.96899 12.9482C8.49719 13.1569 7.96421 13.1847 7.4729 13.0273C6.9818 12.8699 6.56477 12.5375 6.302 12.0938L10.1301 10.4004Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0647 8.81543C7.5366 8.60636 8.0692 8.57802 8.56079 8.73535C9.05223 8.89278 9.46897 9.22477 9.73169 9.66895L5.90259 11.3623C5.75108 10.8694 5.7854 10.3374 5.99927 9.86816C6.21332 9.3988 6.59301 9.02431 7.0647 8.81543ZM6.49438 10.5918C6.51263 10.604 6.53216 10.614 6.552 10.623C6.53156 10.6137 6.51232 10.6026 6.49341 10.5908L6.49438 10.5918Z"
        fill="currentColor"
      />
      <path
        d="M6.61157 5.58496C7.06107 5.58496 7.42603 5.94992 7.42603 6.39941C7.42561 6.84856 7.06081 7.21289 6.61157 7.21289C6.16252 7.21268 5.79851 6.84842 5.7981 6.39941C5.7981 5.95005 6.16226 5.58518 6.61157 5.58496Z"
        fill="currentColor"
      />
      <path
        d="M9.73853 5.86816C10.053 5.86816 10.3078 6.12301 10.3079 6.4375C10.3077 6.75188 10.0529 7.00684 9.73853 7.00684C9.42419 7.00673 9.16939 6.75181 9.16919 6.4375C9.16926 6.12308 9.42411 5.86827 9.73853 5.86816Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9954 14.9629H4.02173L2.37036 1.04102H13.6624L11.9954 14.9629ZM4.96802 13.5977H11.051L12.137 4.53125H3.89185L4.96802 13.5977Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3972 11.7004C11.5677 12.2552 11.5287 12.854 11.2878 13.3821C11.0469 13.9099 10.6202 14.3318 10.0896 14.5667C9.55904 14.8012 8.96044 14.8333 8.40796 14.6565C7.85522 14.4795 7.38629 14.1051 7.09058 13.6057L11.3972 11.7004Z"
        fill="currentColor"
      />
      <path
        d="M7.94702 9.91724C8.47798 9.68194 9.0775 9.64939 9.63062 9.82642C10.1836 10.0034 10.6524 10.3775 10.948 10.8772L6.64038 12.7825C6.46994 12.2279 6.50911 11.6297 6.74976 11.1018C6.99051 10.5739 7.41653 10.1522 7.94702 9.91724Z"
        fill="currentColor"
      />
      <path
        d="M11.6853 8.0022C12.2212 8.00244 12.6558 8.44986 12.656 9.0022C12.6558 9.55453 12.2212 10.0029 11.6853 10.0032C11.1493 10.0031 10.7138 9.55462 10.7136 9.0022C10.7138 8.44978 11.1493 8.0023 11.6853 8.0022Z"
        fill="currentColor"
      />
      <path
        d="M5.78784 8.6731C6.15029 8.67328 6.44409 8.96686 6.44409 9.32935C6.44389 9.69166 6.15016 9.98541 5.78784 9.9856C5.42545 9.9855 5.13082 9.69171 5.13062 9.32935C5.13062 8.96681 5.42532 8.67319 5.78784 8.6731Z"
        fill="currentColor"
      />
      <path
        d="M7.43823 5.58228C7.94386 5.58228 8.35417 5.9917 8.35425 6.49731C8.35405 7.00283 7.94379 7.41333 7.43823 7.41333C6.9328 7.41318 6.52339 7.00274 6.52319 6.49731C6.52327 5.99179 6.93273 5.58242 7.43823 5.58228Z"
        fill="currentColor"
      />
      <path
        d="M10.7556 5.84985C11.1093 5.84991 11.3961 6.13679 11.3962 6.49048C11.396 6.84414 11.1093 7.13105 10.7556 7.1311C10.402 7.131 10.1152 6.84411 10.115 6.49048C10.1152 6.13682 10.4019 5.84995 10.7556 5.84985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4949 16.8333H4.52417L2.66675 1.17114H15.3699L13.4949 16.8333ZM5.44995 15.2971H12.571L13.7917 5.0979H4.23999L5.44995 15.2971Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1705 15.5977C15.3979 16.3372 15.3469 17.1349 15.026 17.8389C14.7048 18.543 14.1359 19.1058 13.4283 19.419C12.7207 19.7319 11.9221 19.7741 11.1852 19.5381C10.4483 19.3021 9.82353 18.8036 9.42932 18.1378L15.1705 15.5977Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5719 13.2198C11.2798 12.9061 12.0786 12.8637 12.816 13.0997C13.5534 13.3358 14.1787 13.8346 14.5729 14.501L8.82971 17.0411C8.60231 16.3016 8.65346 15.5038 8.97424 14.7999C9.29534 14.0958 9.86431 13.5331 10.5719 13.2198ZM10.1237 14.4512C9.69534 14.4512 9.34749 14.7984 9.34729 15.2266C9.34729 15.5222 9.51524 15.7754 9.75842 15.9063C9.77307 15.9146 9.78716 15.9237 9.80237 15.9307C9.90048 15.9756 10.0087 16.003 10.1237 16.003C10.552 16.0029 10.899 15.655 10.899 15.2266C10.8988 14.7984 10.5519 14.4513 10.1237 14.4512ZM12.0973 13.293C11.8066 13.293 11.5709 13.5287 11.5709 13.8194C11.571 14.11 11.8066 14.3458 12.0973 14.3458C12.3878 14.3455 12.6236 14.1099 12.6237 13.8194C12.6237 13.5288 12.3878 13.2933 12.0973 13.293Z"
        fill="currentColor"
      />
      <path
        d="M7.55823 12.6631C8.04158 12.6632 8.43309 13.0548 8.43323 13.5381C8.43303 14.0214 8.04154 14.4141 7.55823 14.4141C7.07496 14.414 6.68343 14.0214 6.68323 13.5381C6.68336 13.0549 7.07493 12.6632 7.55823 12.6631Z"
        fill="currentColor"
      />
      <path
        d="M16.1227 11.4005C16.8376 11.4005 17.4176 11.9985 17.4176 12.7354C17.4173 13.472 16.8374 14.0694 16.1227 14.0694C15.4082 14.0691 14.8291 13.4718 14.8287 12.7354C14.8287 11.9987 15.408 11.4007 16.1227 11.4005Z"
        fill="currentColor"
      />
      <path
        d="M9.89319 8.37506C10.5674 8.37515 11.1139 8.92157 11.1139 9.59576C11.1136 10.2697 10.5672 10.8164 9.89319 10.8165C9.21923 10.8164 8.67281 10.2697 8.67249 9.59576C8.67249 8.92158 9.21903 8.37516 9.89319 8.37506Z"
        fill="currentColor"
      />
      <path
        d="M14.5826 8.79889C15.0544 8.79889 15.4371 9.18159 15.4371 9.65338C15.4369 10.125 15.0543 10.5079 14.5826 10.5079C14.1111 10.5077 13.7283 10.1249 13.7281 9.65338C13.7282 9.18172 14.111 8.7991 14.5826 8.79889Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9694 22.4415H6.00842L3.53088 1.55865H20.4694L17.9694 22.4415ZM6.77209 20.3936H17.2067L18.8356 6.79401H5.15881L6.77209 20.3936Z"
        fill="currentColor"
      />
    </svg>
  ),
});
